export default function rejectAfter(ms, value) {
    return new Promise((resolve, reject) => setTimeout(reject, ms, value));
}
